
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/wedding/detail",
      function () {
        return require("private-next-pages/[hid]/wedding/detail.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[hid]/wedding/detail"])
      });
    }
  